/*
Cabinet Catches

  --type <string> | ['Magnetic', 'Ball', 'Spring', 'Elbow']
  --pair <boolean::switch> | ['Pair', 'Individual']
  --single <boolean::switch> | ['Single', 'Double']
*/
import { type } from '@/modules/standardItems/schemas/baseFilters'
import hardwareFilters from '@/modules/standardItems/schemas/hardware/filters'

export default [
  ...hardwareFilters,
  type(),
  {
    label: 'Single',
    value: 'single',
    type: 'checkboxList',
    trueValue: 'Single',
    falseValue: 'Double'
  }
]
